import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AptInfo from '../common/AptInfo';
import Button from '../common/Button';
import Footer from '../common/Footer';
import Input from '../common/Input';
import Title from '../common/Title';
import { aptInfo } from '../fetchers';
import axios from 'axios';

function Login() {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [domain, setDomain] = useState('');
  const [aptName, setAptName] = useState('');
  const [imgUrl, setImgUrl] = useState('');

  const HOST = window.location.hostname;
  useEffect(() => {
    (async () => {
      const {
        apt: { name, domain, siteLogoUrl },
      } = await aptInfo(HOST);

      setAptName(name);
      setDomain(domain);
      setImgUrl(siteLogoUrl);
    })();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append('tbID', id);
    formData.append('tbPWD', password);

    await axios({
      url: '/common/MOBILE_N2/exec/procLogin.php',
      method: 'POST',
      data: formData,
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          window.location.href = '/';
        } else {
          alert(res.data.message);
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  return (
    aptName && (
      <Container>
        <LoginContainer className='container-fluid col-sm-9 col-md-8 col-xl-4'>
          <LoginForm className='d-flex flex-column py-sm-5' method='post' onSubmit={handleSubmit}>
            <LoginWrapper className='d-flex flex-column px-1 px-md-4 py-4'>
              <Title firstLine={'로그인을'} secondLine={'진행해주세요'} />
              <AptInfo aptName={aptName} />
              <Input placeholder={'아이디를 입력해주세요'} setValue={setId} />
              <Input placeholder={'비밀번호를 입력해주세요'} setValue={setPassword} type='password' />
              <div>
                <Button title='로그인' />
                <Footer />
              </div>
            </LoginWrapper>
          </LoginForm>
        </LoginContainer>
      </Container>
    )
  );
}

const Container = styled.section``;
const LoginContainer = styled.section``;
const LoginForm = styled.form``;
const LoginWrapper = styled.section`
  border-radius: 4px;

  @media screen and (min-width: 768px) {
    border: 1px solid #ededed;
  }
`;

export default Login;
